import SectionHeader from "@/components/shared/comman/requests/viewRequistiion/SectionHeader";
import TextareaField from "@/components/shared/inputs/TextareaField";
import * as Icons from "@/assets/features/requistion";

const OverallCommentsSection = () => {
  return (
    <div className="p-[1.75rem] border border-border rounded-[0.75rem] mt-[1.5rem]">
      <SectionHeader
        icon={<Icons.OverallComments className="w-6 h-6" />}
        title="Overall Comments"
      />

      <div className="mt-10">
        <TextareaField
          label="comments"
          placeholder="Explain What Changes You’re Requesting And Why..."
        />
      </div>
    </div>
  );
};

export default OverallCommentsSection;
